export function ErrorState({
  title,
  body,
  onRetry
}: {
  title: string;
  body: string;
  onRetry?: () => void;
}): JSX.Element {
  return (
    <div className="text-center py-7 px-5" role="alert">
      <div className="text-err font-medium text-sm mb-1.5">{title}</div>
      <div className="text-text-muted text-[11.5px] mb-3">{body}</div>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="px-3.5 py-1.5 bg-panel-2 border border-border text-text rounded-md text-xs cursor-pointer hover:border-border-strong"
        >
          Retry
        </button>
      ) : null}
    </div>
  );
}
